// extracted by mini-css-extract-plugin
module.exports = {"htmlScrollLock":"global__htmlScrollLock__3CXFw","bodyScrollLock":"global__bodyScrollLock__2LVPE"};